module.exports = __webpack_public_path__ + "static/img/101684.2dae52da.png";